import './Loader.css';

const Loader = () => {
    return (
        <div className="loader">
            <div className="spinner"><img src="/spinner.gif" alt="loading"/></div>
        </div>
    )
}
export default Loader;
